import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from '../../../../../ui';
import { AssessmentContext } from '../../../../../utils/contexts/contexts';
import { RootState } from '../../../../../utils/redux_store/store';
import { SelectOptions } from '../../../../../utils/types/react_select_types';
import { Questions } from '../../../view/view_assessment/Questions';

export const CreateQuestions = () => {
  const { assessmentState, setAssessmentState } = useContext(AssessmentContext);
  const skills = useSelector((state: RootState) => state.skills);
  const levels = useSelector((state: RootState) => state.skillLevels);
  const jobTitles = useSelector((state: RootState) => state.jobTitles);
  const subSkills = useSelector((state: RootState) => state.subSkills);
  const [skillList, setSkillList] = useState<SelectOptions[]>(
    skills.skillsList,
  );

  useEffect(() => {
    setSkillList(skills.skillsList);
  }, [skills.skillsList]);

  const navigateBackToBasicInfo = () => {
    setAssessmentState({
      ...assessmentState,
      assessmentPageNo: 1,
    });
  };

  const navigateToNextPage = () => {
    setAssessmentState({
      ...assessmentState,
      assessmentPageNo: 3,
    });
  };

  return (
    <div className='w-full h-full flex flex-col gap-5'>
      <nav
          className='flex w-full justify-between items-center border-b py-3 text-sm'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center space-x-1 md:space-x-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              Create Assesment
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link to={'#'} className=' hover:underline'>
              Questions
            </Link>
          </li>
        </ol>
      </nav>
      <p className='text-primary-textGray'>
        You can set up questions for assessment by searching que. from existing
        question bank / by creating new ones / by uploading a file and
        generating questions.
      </p>
      <div>
        <Questions
            assessmentId={assessmentState.assessmentId}
            skillList={skillList}
            levelList={levels.levelList}
            jobTitleList={jobTitles.jobTitlesList}
            subSkillList={subSkills.subSkillsList}
            setSkillList={setSkillList}
        />
        <div className='flex justify-end gap-3 pt-4 border-t'>
          <Button
              onClick={navigateBackToBasicInfo}
              variant='secondary'
              label='Back'
          />
          <Button onClick={navigateToNextPage} variant='primary' label='Next' />
        </div>
      </div>
    </div>
  );
};
